import { Helmet } from 'react-helmet';

export default function SEO({ path }) {
  const url = `https://www.lipaworld.com${path}`;

  return (
    <Helmet>
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
